import { useEffect, useState } from 'react';
import { REDUCED_MOTION_QUERY } from './useMotionPrefs';

// Cycles 0..count-1 every `interval` ms. Stays on 0 (no timer at all) when reduced motion is requested.
const useRotatingIndex = (count, interval = 3500) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (count < 2 || typeof window === 'undefined') return undefined;
        const media = typeof window.matchMedia === 'function' ? window.matchMedia(REDUCED_MOTION_QUERY) : null;
        let timer = 0;

        const start = () => {
            window.clearInterval(timer);
            if (media && media.matches) {
                setIndex(0);
                return;
            }
            timer = window.setInterval(() => setIndex(i => (i + 1) % count), interval);
        };

        start();
        if (media && media.addEventListener) media.addEventListener('change', start);
        return () => {
            window.clearInterval(timer);
            if (media && media.removeEventListener) media.removeEventListener('change', start);
        };
    }, [count, interval]);

    return index;
};

export default useRotatingIndex;
